import { ReactNode } from "react";
import { ThemeProvider as StyledComponentThemeProvider } from "styled-components";
import { darkModeAtom } from "../../atoms/user/darkModeAtom";
import { useAtomValue } from "jotai";
import { darkTheme, GlobalStyles, lightTheme } from "../../stories/theme";

export const StyledComponentProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const darkMode = useAtomValue(darkModeAtom);
  return (
    <StyledComponentThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <GlobalStyles theme={darkMode ? darkTheme : lightTheme} />
      {children}
    </StyledComponentThemeProvider>
  );
};
